import React, { useMemo, useEffect } from 'react';
import { useParams, Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { ArrowLeft } from 'lucide-react';
import { getProjectsData } from '../data/projectsData';
import './ProjectDetail.css';

const ProjectDetail = () => {
  const { slug } = useParams();
  const { t } = useTranslation();

  const projects = useMemo(() => getProjectsData(t), [t]);
  const project = useMemo(() => projects.find((item) => item.slug === slug), [projects, slug]);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [slug]);

  if (!project) {
    return (
      <section className="project-detail section-padding">
        <div className="container">
          <div className="project-detail-not-found">
            <h2>{t('project_not_found', 'Project not found')}</h2>
            <Link to="/" className="back-link">
              <ArrowLeft size={18} /> {t('back_to_home', 'Back to Home')}
            </Link>
          </div>
        </div>
      </section>
    );
  }

  const { title, image, category, intro, body, stats } = project;

  return (
    <article className="project-detail">
      <div className="project-detail-hero" style={{ backgroundImage: `url(${image})` }}>
        <div className="project-detail-overlay" />
        <div className="container">
          <div className="project-detail-hero-content">
            <span className="project-detail-category">{category}</span>
            <h1>{title}</h1>
            {intro && <p>{intro}</p>}
          </div>
        </div>
      </div>

      <section className="project-detail-body section-padding">
        <div className="container">
          <div className="project-detail-grid">
            <div className="project-detail-main">
              <div className="project-detail-content">
                {body?.map((paragraph, index) => (
                  <p key={index}>{paragraph}</p>
                ))}
              </div>
              <Link to="/" className="back-link">
                <ArrowLeft size={18} /> {t('back_to_home', 'Back to Home')}
              </Link>
            </div>
            {stats?.length > 0 && (
              <aside className="project-detail-stats">
                <h3>{t('project_stats_title', 'Project Impact')}</h3>
                <div className="project-detail-stats-grid">
                  {stats.map((item, index) => (
                    <div key={index} className="project-detail-stat-card">
                      <span className="stat-value">{item.value}</span>
                      <span className="stat-label">{item.label}</span>
                    </div>
                  ))}
                </div>
              </aside>
            )}
          </div>
        </div>
      </section>
    </article>
  );
};

export default ProjectDetail;
